var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87104 1.8356C4.94008 1.35341 5.29851 1 5.71849 1H12.2815C12.7015 1 13.0599 1.35341 13.129 1.8356L13.9881 7.8356C14.0754 8.44513 13.6715 9 13.1406 9H4.85935C4.32846 9 3.92462 8.44513 4.0119 7.8356L4.87104 1.8356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59059 10.5662C3.75978 10.2201 4.11532 10 4.50533 10H13.4947C13.8847 10 14.2402 10.2201 14.4094 10.5662L14.8982 11.5662C15.2228 12.2301 14.7316 13 13.9835 13H4.01651C3.26839 13 2.77722 12.2301 3.10176 11.5662L3.59059 10.5662Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 16C4.22386 16 4 16.2239 4 16.5C4 16.7761 3.77614 17 3.5 17C3.22386 17 3 16.7761 3 16.5C3 15.6716 3.67157 15 4.5 15H13.5C14.3284 15 15 15.6716 15 16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5C14 16.2239 13.7761 16 13.5 16H4.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13H9.5V15H8.5V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.254c6296ba534b11990f83c3f70c5f9d.svg";
export { ForwardRef as ReactComponent };